import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

function UserInputConfirmation(props) {
  let { header, body, isOpen, handleClose, handleAction, actionButtonText, actionButtonBgColor, actionButtonColor, actionButtonHover, userInput, isDisabled } = props;
  actionButtonBgColor = actionButtonBgColor || '#007bff';
  actionButtonColor = actionButtonColor || 'white';
  actionButtonText = actionButtonText || 'Confirm';

  const actionButton = (
      <Button disabled={isDisabled} onClick={handleAction} backgroundColor={actionButtonBgColor} color={actionButtonColor} _hover={actionButtonHover} mr={3}>
        {actionButtonText}
      </Button>
  );

  return (
      <AlertDialog isOpen={isOpen} onClose={handleClose}>
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                {header}
              </AlertDialogHeader>
              <AlertDialogBody>
                {typeof body === 'function' ? body() : body}
                {userInput}
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button style={{ marginRight: '15px' }} onClick={handleClose}>
                  Cancel
                </Button>
                {actionButton}
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
  );
}

UserInputConfirmation.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]).isRequired,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleAction: PropTypes.func,
  actionButtonText: PropTypes.string,
  actionButtonBgColor: PropTypes.string,
  actionButtonColor: PropTypes.string,
  actionButtonHover: PropTypes.object,
  userInput: PropTypes.element,
  isDisabled: PropTypes.bool
};

export default UserInputConfirmation;
